
const actionTypes = Object.freeze({
    USER_LOGIN_START: 'USER_LOGIN_START',
    USER_LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
    USER_LOGIN_FAIL: 'USER_LOGIN_FAIL',
    USER_LOGOUT: 'USER_LOGOUT',

    SET_USER_INFO: 'SET_USER_INFO',

    ALERT: "ALERT"

})

export default actionTypes